import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    font-family: Helvetica, Sans-Serif;
  }
`;

export default GlobalStyle;
